export default __webpack_public_path__ + "static/media/lock.55b2d37b.svg";